import { createAction, props } from '@ngrx/store';
import { IInssState } from './inss.state';

export const initInssAction = createAction('[Inss Page] Inss page');

export const setInssAction = createAction(
  '[Inss Page] set data',
  props<IInssState>()
);
